import { FormattedMessage } from 'react-intl';

import { THead, HeaderItem, HeaderItemWrapper } from 'styles/table';

function TableFormHeader(props) {
  const { titles } = props;

  const mappedTitles = mapTitles(titles);

  const headerItems = mappedTitles
    .filter((title) => !title.hidden)
    .map((title) => (
      // @ts-expect-error TS(2769): No overload matches this call.
      <HeaderItem key={title.id} width={title.width}>
        <HeaderItemWrapper>
          {typeof title.content === 'object' ? <FormattedMessage id={title.content.id} /> : title.content}
        </HeaderItemWrapper>
      </HeaderItem>
    ));

  return (
    <THead>
      <tr>{headerItems}</tr>
    </THead>
  );
}

function mapTitles(titles) {
  return titles.map((title, index) => {
    if (typeof title === 'string') {
      return {
        content: title,
        hidden: false,
        id: index,
      };
    } else {
      return {
        ...title,
        id: index,
      };
    }
  });
}

export default TableFormHeader;
